import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { Button } from './ui/Button';
const faqs = [{
  q: '¿Necesito experiencia previa?',
  a: 'No. Está diseñado para principiantes. Todo se explica desde cero, paso a paso.'
}, {
  q: '¿Es material digital?',
  a: 'Sí. Acceso inmediato desde cualquier dispositivo (celular, tablet o computadora). No tenés que esperar envíos.'
}, {
  q: '¿Necesito un local?',
  a: 'No. Podés comenzar desde casa o haciendo servicios a domicilio, como hacen muchas de nuestras alumnas.'
}, {
  q: '¿Es solo teoría?',
  a: 'No. Es formación práctica y estructurada, enfocada en que aprendas a realizar los servicios.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const handlePurchase = () => {
    window.location.href = 'https://checkout.recursostop.shop/cart/45775377465540:1';
  };
  return <section className="py-20 bg-[#FFF8F0]" data-id="element-86">
      <div className="max-w-3xl mx-auto px-4" data-id="element-87">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-10" data-id="element-88">
          ❓ Preguntas frecuentes
        </h2>

        <div className="space-y-4 mb-10" data-id="element-89">
          {faqs.map((faq, idx) => <div key={idx} className="border border-purple-200 rounded-lg overflow-hidden" data-id="element-90">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full flex items-center justify-between p-4 text-left bg-purple-50 hover:bg-purple-100 transition-colors" data-id="element-91">
                <span className="font-bold text-gray-900" data-id="element-92">{faq.q}</span>
                {openIndex === idx ? <Minus className="w-5 h-5 text-gray-500" data-id="element-93" /> : <Plus className="w-5 h-5 text-gray-500" data-id="element-94" />}
              </button>
              {openIndex === idx && <div className="p-4 bg-white text-gray-700 border-t border-gray-200" data-id="element-95">
                  {faq.a}
                </div>}
            </div>)}
        </div>

        <div className="text-center bg-[#3D1F2E] text-white p-8 md:p-12 rounded-2xl shadow-2xl" data-id="element-96">
          <h3 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-97">
            🚀 La decisión es simple
          </h3>
          <p className="text-lg text-gray-300 mb-8" data-id="element-98">
            Seguir igual… O invertir en aprender habilidades que sí tienen
            demanda real. <br data-id="element-99" />
            Esto no es un gasto. Es una herramienta para generar ingresos.
          </p>
          <div className="mb-8" data-id="element-100">
            <p className="text-xl font-bold text-purple-300" data-id="element-101">
              🔥 MegaPack Estética Integral
            </p>
            <p className="text-sm text-gray-400" data-id="element-102">
              Formación completa. Práctica. Profesional. Rentable.
            </p>
          </div>
          <Button onClick={handlePurchase} size="xl" className="w-full md:w-auto px-12" data-id="element-103">
            👉 ACCEDER AHORA
          </Button>
          <div className="flex items-center justify-center gap-4 mt-6 opacity-70" data-id="element-104">
            <img src="https://cdn.magicpatterns.com/uploads/fL9kACheWktd2dhJwcnkzQ/mercado_pago.jpg" alt="Mercado Pago" className="h-8 rounded" data-id="element-105" />
          </div>
        </div>
      </div>
    </section>;
}